<template>
  <v-container fluid class="d-flex flex-column layout-container">
    <!-- Cabeçalho Fixo -->
    <v-app-bar v-if="!loadingDialog" app color="primary" dark class="header-bar">
      <!-- Título -->
      <v-toolbar-title>
        <span v-if="expediente?.data_abertura">
          EXPEDIENTE INICIADO ÀS - {{ formatarDataHora(expediente.data_abertura) }}
        </span>
        <span v-else>
          Nenhum expediente iniciado
        </span>

        Setor {{ this.id_setor }} {{ setorSelecionado?.descricao_setor || "Desconhecido" }} <br> Chefe:
        {{ chefeSelecionado?.nome || "Desconhecido" }}

      </v-toolbar-title>


      <!-- Espaçador para empurrar o botão para a direita -->
      <v-spacer></v-spacer>

      <!-- Botão -->
      <v-btn icon @click="voltarMenu" class="mr-2" color="white">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-app-bar>
    <h3 class="text-center font-weight-bold">Menu de Expediente: {{ status.descricao }} {{ status.nome }}</h3>

    <!-- Área de Conteúdo Scrollável -->
    <v-main class="content-area">
      <v-container>



<!-- Diálogo de Confirmação Melhorado -->
<v-dialog v-model="mostrarDialogoConfirmacao" max-width="450" persistent>
  <v-card class="mx-auto" elevation="8">
    <!-- Cabeçalho com ícone -->
    <v-card-title class="d-flex align-center justify-center pa-4 white--text" 
                  style="background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);">
      <v-icon left color="white" size="28">mdi-help-circle</v-icon>
      <span class="text-h6 font-weight-bold">Confirmação de Ação</span>
    </v-card-title>

    <!-- Conteúdo -->
    <v-card-text class="pa-6">
      <div class="text-center mb-4">
        <v-icon color="warning" size="64" class="mb-3">
          mdi-alert-circle-outline
        </v-icon>
      </div>
      
      <div class="text-center">
        <p class="text-body-1 mb-2">Você tem certeza que deseja executar a seguinte ação?</p>
        <v-chip 
          color="primary" 
          outlined 
          large 
          class="font-weight-bold px-4 py-2"
        >
          {{ statusDialogo }}
        </v-chip>
      </div>

      <v-divider class="my-4"></v-divider>
      
      <div class="text-center">
        <p class="text-caption text--secondary mb-0">
          Esta ação não poderá ser desfeita facilmente.
        </p>
      </div>
    </v-card-text>

    <!-- Ações -->
    <v-card-actions class="pa-4 pt-0">
      <v-spacer></v-spacer>
      
      <v-btn 
        color="grey" 
        outlined
        large
        class="mr-3 px-6"
        @click="fecharDialogoConfirmacao"
      >
        <v-icon left>mdi-close</v-icon>
        Cancelar
      </v-btn>
      
      <v-btn 
        color="success" 
        large
        class="px-6 white--text"
        elevation="2"
        @click="salvarMudancasAlmocoLancheFim"
      >
        <v-icon left>mdi-check</v-icon>
        Confirmar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


        <!-- Diálogo de Confirmação Funcionarios -->
        <v-dialog v-model="mostrarDialogoConfirmacaoFuncinario" max-width="800px">
          <v-card>
            <!-- Cabeçalho do Diálogo -->


            <v-card-title class="text-h6 d-flex align-center"
              style="background: linear-gradient(90deg, #b0bec5, #90a4ae); color: #212121; padding: 10px; border-radius: 4px;">
              <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
              <span>Confirmação </span>
            </v-card-title>






            <v-divider></v-divider>

            <!-- Texto de Confirmação -->
            <v-card-text>
              <p>Você deseja confirmar a ação: <strong>{{ opcao_selected.titulo }}</strong>?</p>

              <!-- Tabela com Funcionários Selecionados -->
              <v-data-table :items="funcionariosSelecionadosDetalhes" :headers="[
                { title: 'ID', value: 'id_funcionario', align: 'start' },
                { title: 'Nome', value: 'nome' },
                { title: 'Status', value: 'status_atual' }
              ]" dense class="elevation-1" hide-default-footer style="max-height: 300px; overflow-y: auto;">
                <!-- Template personalizado para status -->
                <template #bottom></template>

                <template #item.status_atual="{ item }">
                  <v-chip :color="item.status_atual === 'Trabalhando' ? 'green' : 'red'" dark small>
                    {{ item.status_atual }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card-text>

            <!-- Botões de Ação -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="mostrarDialogoConfirmacaoFuncinario = false">
                Cancelar
              </v-btn>
              <v-btn color="green" text @click="salvarMudancasFuncionarioSemAbertura">
                Confirmar 2
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>






        <!-- Diálogo de Carregamento -->
        <v-dialog v-model="loadingDialog" persistent max-width="300">
          <v-card>
            <v-card-text class="text-center">
              <v-progress-circular indeterminate color="green"></v-progress-circular>
              <p>{{ mensagemDialog }}</p>
            </v-card-text>
          </v-card>
        </v-dialog>


        <v-dialog v-model="mostrarDialogo" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <!-- Toolbar -->
            <v-toolbar color="primary">
              <v-toolbar-title>
                <v-icon>mdi-account-multiple</v-icon>
                {{ opcao_selected.titulo }}
              </v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="fecharQuadroFuncionarios">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <!-- Conteúdo do diálogo -->
            <v-container fluid>
              <v-row dense>


                <!-- Card de Funcionários Disponíveis -->
                <v-col cols="12" class="mt-4">
                  <v-card class="pa-3 elevation-2">
                    <!-- Título com gradiente azul claro -->



                    <v-card-title class="text-h6 d-flex align-center"
                      style="background: linear-gradient(90deg, #b0bec5, #90a4ae); color: #212121; padding: 10px; border-radius: 4px;">
                      <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
                      <span>Funcionários Disponíveis</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <!-- Filtros -->
                      <v-row dense>
                        <v-col cols="5">
                          <v-select v-model="opcaoSelecionadaNome" :items="nomesUnicos" item-title="label"
                            item-key="value" label="Selecione Funcionário" dense outlined multiple></v-select>
                        </v-col>
                        <v-col cols="2">
                          <v-select v-model="opcaoSelecionadaOrdem" :items="ordensUnicas" item-title="label"
                            item-key="value" label="Selecione Ordem" dense outlined multiple></v-select>
                        </v-col>
                        <v-col cols="2">
                          <v-select v-model="opcaoSelecionadaPedido" :items="pedidosUnicos" item-title="label"
                            item-key="value" label="Selecione Pedido" dense outlined multiple></v-select>
                        </v-col>
                        <v-col cols="3">
                          <v-select v-model="opcaoSelecionadaStatus" :items="statasUnicos" item-title="label"
                            item-key="value" label="Selecione Status" dense outlined multiple></v-select>
                        </v-col>
                        <v-col cols="6">
                          <!-- <v-text-field v-model="search" label="Buscar funcionários" dense outlined
                            prepend-inner-icon="mdi-magnify" clearable></v-text-field> -->
                        </v-col>


                        <v-col cols="6">

                          <v-row justify="end" align="center" dense class="mt-0 mb-0">
                            <v-col cols="auto">
                              <v-btn color="error" @click="limparFiltros">Limpar Filtros</v-btn>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn color="primary" @click="selecionarTodos">Selecionar Todos</v-btn>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn color="error" @click="desmarcarTodos">Desmarcar Todos</v-btn>
                            </v-col>
                          </v-row>
                        </v-col>

                      </v-row>

                      <!-- Botões de Ação -->


                      <!-- Tabela -->
                      <v-data-table
                        :headers="opcao_selected.regra === 'mudanca_setor' ? headersFuncionariosMudancaSetor : headersFuncionarios"
                        :items="filtrarFuncionarios()" item-value="id" dense class="elevation-1 mt-2">

                        <!-- Template para status permanece o mesmo -->
                        <template #item.status_atual="{ item }">
                          <v-chip :color="item.status_atual === 'Trabalhando' ? 'green' : 'red'" dark small>
                            {{ item.status_atual }}
                          </v-chip>
                        </template>

                        <template #item.selecionado="{ item }">
                          <v-checkbox v-model="item.selecionado" color="primary" />
                        </template>

                        <!-- Novo template para a coluna "Nova Ordem" apenas em Mudança de Setor -->
                        <!-- Novo template para a coluna "Nova Ordem" apenas em Mudança de Setor -->
                        <template v-if="opcao_selected.regra === 'mudanca_setor'" #item.nova_ordem="{ item }">
                          <v-autocomplete v-model="item.nova_ordem" :items="ordensDisponiveis(item)" item-title="text"
                            item-value="value" multiple dense outlined hide-details clearable
                            placeholder="Sem alteração" chips small-chips deletable-chips>
                          </v-autocomplete>

                        </template>


                      </v-data-table>

                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Card de Funcionários Selecionados -->
                <v-col cols="12">
                  <v-card class="pa-3 elevation-2">
                    <!-- Título com gradiente azul claro -->
                    <v-card-title class="text-h6 d-flex justify-space-between align-center"
                      style="background: linear-gradient(90deg, #b0bec5, #90a4ae); color: #212121; padding: 10px; border-radius: 4px;">
                      <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
                        <span>Funcionários Selecionados para {{ opcao_selected.titulo }}</span>
                      </div>
                      <v-btn color="primary" v-show="funcionariosSelecionadosDetalhes.length > 0"
                        @click="confirmarSelecaoFuncionarios" outlined>
                        Confirmar
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-container fluid>
                        <v-row class="font-weight-bold text-body-2" dense>
                          <v-col cols="2">ID</v-col>
                          <v-col cols="4">Nome</v-col>
                          <v-col cols="2">Status</v-col>
                          <v-col cols="2">Ordem</v-col>
                          <v-col cols="2">Nova Ordem</v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row v-for="funcionario in funcionariosSelecionadosDetalhes" :key="funcionario.id_funcionario"
                          dense class="py-1">
                          <v-col cols="2" class="text-truncate">{{ funcionario.id_funcionario }}</v-col>
                          <v-col cols="4" class="text-truncate">{{ funcionario.nome }}</v-col>
                          <v-col cols="2">{{ funcionario.status_atual }}</v-col>
                          <v-col cols="2">{{ funcionario.numero_ordem || 'N/A' }}</v-col>
                          <v-col cols="2">
                            {{ funcionario.nova_ordem ? funcionario.nova_ordem.map(ordem =>
                              ordem.id_numero_ordem).join(', ') :
                              'N/A' }}


                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-col>

              </v-row>
            </v-container>
          </v-card>
        </v-dialog>





        <v-row class="menu-expediente" justify="center">
          <v-col cols="12" sm="6" md="5" v-for="(opcao, index) in opcoes" :key="index">
            <v-card outlined class="option-card" @click="isBotaoHabilitado(opcao) && abrirDialogo(opcao)"
              :disabled="!isBotaoHabilitado(opcao)"
              :style="`background: ${opcao.gradiente}; opacity: ${!isBotaoHabilitado(opcao) ? 0.5 : 1}; cursor: ${!isBotaoHabilitado(opcao) ? 'not-allowed' : 'pointer'}`">
              <v-card-title class="d-flex align-center justify-center">
                <v-icon class="menu-icon" :color="opcao.cor" :size="isMobile ? '48' : '64'">
                  {{ opcao.icone }}
                </v-icon>
              </v-card-title>
              <v-card-text class="text-center text-white font-weight-bold">
                {{ opcao.titulo }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>







      </v-container>
    </v-main>

    <!-- Rodapé Fixo -->
    <v-footer v-if="!loadingDialog" app padless class="footer-bar">

    </v-footer>
    <ConflitoSetorDialog :conflitos="conflitosSetor" @fechar="conflitosSetor = []" />
  </v-container>
</template>

<script>

import { useUserStore } from "@/store/userStore";
import ConflitoSetorDialog from './ConflitoSetorDialog.vue';
import { maquinaMapaService } from "@/services/maquinaMapaService";
import { aberturaExpedienteService } from "@/services/aberturaExpedienteService";
import { toastInjectionKey, useToast } from "vue-toastification";

const toast = useToast();

export default {
  components: { ConflitoSetorDialog },
  data() {
    return {
      conflitosSetor: [],

      // ... (outros dados)
      headersFuncionariosMudancaSetor: [ // <-- Linha adicionada
        { title: "ID Funcionário", value: "id_funcionario", sortable: true },
        { title: "Nome", value: "nome", sortable: true },
        { title: "Status Atual", value: "status_atual", sortable: false },
        { title: "Ordem", value: "numero_ordem", sortable: true },
        { title: "Pedido", value: "numero_pedido", sortable: true },
        { title: "Etapa", value: "etapa", sortable: true },
        { title: "Modelo", value: "modelo", sortable: true },
        { title: "Selecionado", value: "selecionado", sortable: false },
        { title: "Nova Ordem", value: "nova_ordem", sortable: false }, // <-- Linha adicionada
      ],

      mostrarDialogoConfirmacaoFuncinario: false,
      opcaoSelecionadaPedido: null,
      opcaoSelecionadaOrdem: null,
      opcaoSelecionadaNome: null,
      opcaoSelecionadaStatus: null,

      nomesUnicos: [], // Filtro único para nomes
      ordensUnicas: [], // Filtro único para ordens
      pedidosUnicos: [], // Filtro único para pedidos
      statasUnicos: [], // Filtro único para status




      acaoEscolhidaMudancaStatus: null,
      search: "", // Variável para armazenar o termo de busca

      id_setor: null,  // ou um valor padrão apropriado

      opcao_selected: {},
      status: {
        nome: "fechado", // Padrão: fechado
      },

      funcionariosSelecionados: [], // Armazena os funcionários selecionados
      mostrarDialogoConfirmacao: false, // Controla o diálogo de confirmação
      ordensDoSetor: [], // Armazena as ordens do setor
      mostrarDialogo: false, // Controla o diálogo de funcionários
      quadroFuncionarios: [], // Armazena os dados do quadro de funcionários
      headersFuncionarios: [
        { title: "ID Funcionário", value: "id_funcionario", sortable: true },
        { title: "Nome", value: "nome", sortable: true },
        { title: "Status Atual", value: "status_atual", sortable: false },
        { title: "Ordem", value: "numero_ordem", sortable: true },
        { title: "Pedido", value: "numero_pedido", sortable: true },
        { title: "Etapa", value: "etapa", sortable: true },
        { title: "Modelo", value: "modelo", sortable: true },
        { title: "Selecionado", value: "selecionado", sortable: false },
      ],



      mensagemDialog: "Carregando dados...",
      loadingDialog: true,
      isMobile: window.innerWidth <= 600,
      id_chefe: "",
      id_chefe_setor: null,
      setorSelecionado: null,
      expediente: [],
      chefeSelecionado: null,
      opcoes: [
        {
          titulo: "Início do Trabalho Ordem De Produção",
          icone: "mdi-clock-start",
          cor: "white",
          gradiente: "linear-gradient(45deg, #43a047, #66bb6a)",
          regra: "abertura_dia",
          routeMobile: "AberturaExpedienteDesktop",
          routeDesktop: "AberturaExpedienteDesktop",
          local: "",
          id_status_final: 15,
        },
        {
          titulo: "Consulta Historico de Horas Trabalhadas",
          icone: "mdi-clipboard-text-clock",
          cor: "white",
          gradiente: "linear-gradient(45deg, #1e88e5, #42a5f5)", // Gradiente azul
          regra: "consultarHorasTrabalhadas",
          routeMobile: "ConsultaQuadroHorarioMobile",
          routeDesktop: "ConsultaQuadroHorarioMobile",
          local: "",
          id_status_final: 15,
          arrayFiltro: [

          ],
        },
        // {
        //   titulo: "Visualizar Quadro De Funcionários",
        //   icone: "mdi-clock-time-eight-outline",
        //   cor: "white",
        //   gradiente: "linear-gradient(45deg, #d3d3d3, #d3d3d3, #d3d3d3)",
        //   routeMobile: "",
        //   routeDesktop: "",
        //   local: "abrirQuadroFuncionarios",
        //   regra: "visualizar_quadro",
        // },
        {
          titulo: "Intervalo para Lanche",
          icone: "mdi-coffee",
          cor: "white",
          gradiente: "linear-gradient(45deg, #795548, #a1887f)",
          regra: "intervalo_lanche",
          id_status_final: 16,
        },
        {
          titulo: "Retorno do Lanche",
          icone: "mdi-coffee-outline",
          cor: "white",
          gradiente: "linear-gradient(45deg, #8e24aa, #ba68c8)",
          regra: "retorno_lanche",
          id_status_final: 17,
        },
        {
          titulo: "Intervalo para Almoço",
          icone: "mdi-food",
          cor: "white",
          gradiente: "linear-gradient(45deg, #ffa726, #ffb74d)",
          regra: "intervalo_almoco",
          id_status_final: 18,
        },
        {
          titulo: "Retorno do Almoço",
          icone: "mdi-food-fork-drink",
          cor: "white",
          gradiente: "linear-gradient(45deg, #29b6f6, #4fc3f7)",
          regra: "retorno_almoco",
          id_status_final: 19,
        },
        {
          titulo: "Saída com Justificativa",
          icone: "mdi-medical-bag",
          cor: "white",
          gradiente: "linear-gradient(45deg, #ff7043, #ff8a65)",
          regra: "saida_com_justificativa",
          local: "saida_com_justificativa",

          id_status_final: 20,
        },
        {
          titulo: "Saída sem Justificativa",
          icone: "mdi-account-off",
          cor: "white",
          gradiente: "linear-gradient(45deg, #26a69a, #4db6ac)",
          regra: "saida_sem_justificativa",
          local: "saida_sem_justificativa",

          id_status_final: 21,
        },
        {
          titulo: "Mudança de setor / Encerramento de ordem",
          icone: "mdi-account-convert",
          cor: "white",
          gradiente: "linear-gradient(45deg, #0d47a1, #1976d2)", // Azul mais escuro
          regra: "mudanca_setor",
          local: "mudanca_setor",
          id_status_final: 20,
        },
        {
          titulo: "Fim do Expediente",
          icone: "mdi-clock-end",
          cor: "white",
          gradiente: "linear-gradient(45deg, #e53935, #ef5350)",
          regra: "fim",
          id_status_final: 22,
        },
      ]

    };
  },
  methods: {

    async salvarMudancasAlmocoLancheFim() {
      this.loadingDialog = true; // Mostra o carregamento
      this.mensagemDialog = "Alterando Status..."; // Mensagem de carregamento
      const toast = useToast(); // Para exibir mensagens de sucesso ou erro

      try {
        const dadosMudancaStatus = {
          funcionarios: [
            {
              id_abertura: this.expediente.id, // ID da abertura do expediente
              id_status_final: this.opcao_selected.id_status_final, // Status final atualizado
            },
          ],
          observacao: "Atualizado automaticamente", // Observação padrão
        };

        // Chama o serviço para atualizar o status
        const response = await aberturaExpedienteService.mudarStatusExpediente(dadosMudancaStatus);

        // Verifica o sucesso da operação
        if (response.success) {





          this.mostrarDialogoConfirmacao = false; // Fecha o diálogo de confirmação
          this.buscarChefe();

          toast.success("Mudança de status realizada com sucesso!");
        } else {
          toast.warning(response.message || "Nenhuma alteração realizada.");
        }
      } catch (error) {
        console.error("Erro ao alterar status:", error);

        // Exibe uma mensagem genérica em caso de erro
        toast.error("Erro ao alterar o status. Tente novamente.");
      } finally {
        this.mostrarDialogoConfirmacao = false; // Fecha o diálogo de confirmação
        this.mostrarDialogo = false; // Fecha o diálogo de
        this.loadingDialog = false; // Oculta o carregamento
      }
    }
    ,

    async salvarMudancasFuncionarioSemAbertura() {
      this.loadingDialog = true; // Mostra o carregamento
      this.mensagemDialog = "Alterando Status Por Funcionário..."; // Mensagem de carregamento
      const toast = useToast(); // Para exibir mensagens de sucesso ou erro

      try {
        // Cria o array de funcionários selecionados
        const funcionarios = this.funcionariosSelecionadosDetalhes.map((funcionario) => ({
          id_abertura: this.expediente.id, // ID da abertura do expediente
          id_funcionario: funcionario.id_funcionario, // ID do funcionário
          id_ordem: funcionario.id_ordem, // ID da ordem
          id_ordem_status: funcionario.id_status, // Status da ordem
          id_status_final: this.opcao_selected.id_status_final, // Status final atualizado
        }));

        // Monta o payload com o array completo
        const dadosMudancaStatus = {
          funcionarios, // Array de funcionários
          observacao: "Atualizado automaticamente", // Observação padrão
        };



        // Chama o serviço para atualizar o status em uma única requisição
        const response = await aberturaExpedienteService.mudarStatusExpediente(dadosMudancaStatus);

        // Verifica o sucesso da operação
        if (response.success) {

          // vamos verificar se tiver alguma ordem nova para o funcionario

          const existe = this.funcionariosSelecionadosDetalhes.some(funcionario =>
    funcionario.nova_ordem && funcionario.nova_ordem.length > 0
  );
          if (existe) {
          this.salvarAberturaNova();
          }

          toast.success("Mudança de status realizada com sucesso para todos os funcionários.");
        } else {
          toast.warning(response.message || "Nenhuma alteração realizada.");
        }

        // Fecha o diálogo de confirmação
        this.mostrarDialogoConfirmacaoFuncinario = false;
        this.mostrarDialogo = false;

        this.buscarChefe(); // Atualiza os dados do chefe/setor

      } catch (error) {
        console.error("Erro ao alterar status:", error);

        // Exibe uma mensagem genérica em caso de erro
        toast.error("Erro ao alterar o status. Tente novamente.");
      } finally {

        this.mostrarDialogoConfirmacaoFuncinario = false;
        this.mostrarDialogo = false;

        this.loadingDialog = false; // Oculta o carregamento
      }
    },

    async salvarAberturaNova() {
      console.log("salvarAberturaNova");
      this.loadingDialog = true; // Mostra o carregamento
      this.mensagemDialog = "Salvando abertura..."; // Mensagem de carregamento
      const toast = useToast(); // Para exibir mensagens de sucesso ou erro

      try {
        // Inicializa arrays para armazenar dados de ordens e funcionários
        const expedienteFuncionarios = []; // [linha adicionada]
        const expedienteOrdensMap = new Map(); // Usado para evitar duplicatas em expediente_ordem [linha adicionada]

        // Itera sobre cada funcionário selecionado com detalhes
        this.funcionariosSelecionadosDetalhes.forEach(funcionario => { // [linha alterada]
          // Se existir nova_ordem para o funcionário
          if (funcionario.nova_ordem && funcionario.nova_ordem.length > 0) { // [linha adicionada]
            funcionario.nova_ordem.forEach(novaOrdemItem => { // [linha adicionada]
              expedienteFuncionarios.push({                         // [linha adicionada]
                id_funcionario: funcionario.id_funcionario,        // [linha adicionada]
                id_ordem: novaOrdemItem.id_ordem,                // [linha adicionada]
                id_ordem_status: novaOrdemItem.id_ordem_status  ,          // Presumindo que id_status vem do funcionário [linha adicionada]
                id_status_inicio: 15,                            // [linha adicionada]
                inicio_at: this.dataAbertura,                    // [linha adicionada]
                motivo: "abertura",                              // [linha adicionada]
              });                                                 // [linha adicionada]
              // Adiciona a ordem ao mapa para garantir ordens únicas
              expedienteOrdensMap.set(novaOrdemItem.id_ordem, {   // [linha adicionada]
                id_ordem: novaOrdemItem.id_ordem,               // [linha adicionada]
                id_ordem_status: novaOrdemItem.id_ordem_status  ,          // Presumindo que id_status vem do funcionário [linha adicionada]
              });                                               // [linha adicionada]
            });                                                   // [linha adicionada]
          } else {
            // Se não houver nova_ordem, usa a ordem atual do funcionário
            expedienteFuncionarios.push({                        // [linha adicionada]
              id_funcionario: funcionario.id_funcionario,
              id_ordem: funcionario.id_ordem,                   // Presumindo que id_ordem vem do funcionário
              id_ordem_status: funcionario.id_status,
              id_status_inicio: 15,
              inicio_at: this.dataAbertura,
              motivo: "abertura",
            });
            expedienteOrdensMap.set(funcionario.id_ordem, {      // [linha adicionada]
              id_ordem: funcionario.id_ordem,                   // [linha adicionada]
              id_ordem_status: funcionario.id_status          // [linha adicionada]
            });                                                 // [linha adicionada]
          }
        });

        // Montar os dados para envio usando os arrays construídos
        const dadosAbertura = {
          chefe_id: this.chefeSelecionado.id,
          setor_id: this.setorSelecionado.id,
          observacao: this.observacao || "",
          data_abertura: this.dataAbertura,
          expediente_ordem: Array.from(expedienteOrdensMap.values()), // [linha alterada]
          expediente_funcionarios: expedienteFuncionarios,            // [linha alterada]
        };

        console.log("Dados de automatica abertura por :", dadosAbertura);

        // Verifica se há dados de funcionários para enviar
        if (dadosAbertura.expediente_funcionarios.length === 0) {
          toast.warning("Nenhum funcionário está associado a ordens selecionadas.");
          this.loadingDialog = false;
          return;
        }

        // Chama o serviço para salvar a abertura
         const response = await aberturaExpedienteService.salvarAbertura(dadosAbertura);

        // Verificar a resposta da API
        if (response.success) {
          toast.success("Abertura salva com sucesso!");
          this.successDialog = true;
        } else {
          toast.warning("Abertura realizada parcialmente ou com problemas.");
        }
      } catch (error) {
        console.error("Erro ao salvar abertura:", error);
        if (error.code === 'FUNCIONARIO_EM_OUTRO_SETOR') this.conflitosSetor = error.conflitos;
        else toast.error(error.message || "Erro ao salvar a abertura. Tente novamente.");
      } finally {
        this.loadingDialog = false; // Oculta o carregamento
      }
    }
    ,



    ordensDisponiveis(funcionario) {
      // Filtrar as ordens disponíveis considerando `funcionariosFiltrados`
      return this.ordensDoSetor.filter(ordem => {
        // Verifica se o funcionário NÃO está vinculado à ordem dentro de `funcionariosFiltrados`
        return !this.filtrarFuncionarios().some(f =>
          f.id_funcionario === funcionario.id_funcionario &&
          f.id_ordem === ordem.id_ordem
        );
      }).map(ordem => ({
        text: ordem.id_numero_ordem, // Texto para exibição no select
        value: ordem                  // Valor da ordem
      }));
    },




    limparFiltros() {
      this.opcaoSelecionadaNome = null;
      this.opcaoSelecionadaOrdem = null;
      this.opcaoSelecionadaPedido = null;
      this.opcaoSelecionadaStatus = null;
      this.search = "";
    },
    filtrarFuncionarios() { // Início do método filtrarFuncionarios
      const termoBusca = this.search ? this.search.toLowerCase() : null; // Busca global
      const termoNumerico = this.search ? parseInt(this.search, 10) : null; // Busca numérica, se aplicável

      return this.quadroFuncionarios.filter((funcionario) => {
        // Verificar correspondência com a busca global
        const matchBusca =
          !termoBusca ||
          funcionario.nome.toLowerCase().includes(termoBusca) ||
          funcionario.status_atual.toLowerCase().includes(termoBusca) ||
          (termoNumerico && (funcionario.numero_ordem === termoNumerico || funcionario.numero_pedido === termoNumerico));

        // Verificar correspondência com os filtros
        const matchNome =
          !this.opcaoSelecionadaNome || this.opcaoSelecionadaNome.length === 0 || this.opcaoSelecionadaNome.includes(funcionario.nome);

        const matchOrdem =
          !this.opcaoSelecionadaOrdem || this.opcaoSelecionadaOrdem.length === 0 || this.opcaoSelecionadaOrdem.includes(funcionario.numero_ordem);

        const matchPedido =
          !this.opcaoSelecionadaPedido || this.opcaoSelecionadaPedido.length === 0 || this.opcaoSelecionadaPedido.includes(funcionario.numero_pedido);

        const matchStatus =
          !this.opcaoSelecionadaStatus || this.opcaoSelecionadaStatus.length === 0 || this.opcaoSelecionadaStatus.includes(funcionario.status_atual);

        // Retornar verdadeiro apenas se todos os filtros forem correspondidos
        return matchBusca && matchNome && matchOrdem && matchPedido && matchStatus;
      });
    }, // <-- Comentário: Fim do método filtrarFuncionarios



    selecionarTodos() {
      // Obtém os funcionários filtrados
      const funcionariosFiltrados = this.filtrarFuncionarios();

      // Atualiza diretamente a propriedade 'selecionado' considerando id_funcionario, id_ordem e id_status_ordem
      this.quadroFuncionarios.forEach((funcionario) => {
        if (
          funcionariosFiltrados.some(
            (f) =>
              f.id_funcionario === funcionario.id_funcionario &&
              f.id_ordem === funcionario.id_ordem &&
              f.id_status === funcionario.id_status // Verifica a combinação dos três campos
          )
        ) {
          funcionario.selecionado = true; // Marca como selecionado
        }
      });
    },


    desmarcarTodos() {
      // Obtém os funcionários filtrados
      const funcionariosFiltrados = this.filtrarFuncionarios();

      // Atualiza diretamente a propriedade 'selecionado' considerando id_funcionario, id_ordem e id_status_ordem
      this.quadroFuncionarios.forEach((funcionario) => {
        if (
          funcionariosFiltrados.some(
            (f) =>
              f.id_funcionario === funcionario.id_funcionario &&
              f.id_ordem === funcionario.id_ordem &&
              f.id_status === funcionario.id_status // Verifica a combinação dos três campos
          )
        ) {
          funcionario.selecionado = false; // Marca como desmarcado]
          funcionario.nova_ordem = null; // Limpa a nova ordem
        }
      });
    },



    confirmarSelecaoFuncionarios() {

      this.mostrarDialogoConfirmacaoFuncinario = true;
    },


    isBotaoHabilitado(opcao) {
      const regra = opcao.regra;

      switch (regra) {
        case "inicio":
          return this.status.nome === "abertura_dia"; // Habilitado apenas quando o status for "abertura_dia"

        case "consultarHorasTrabalhadas":
          return this.status.nome !== "fechado" && this.setorSelecionado;
        case "intervalo_almoco":
          return this.status.nome !== "fechado" &&
            this.status.nome !== "intervalo_almoco" &&
            this.status.nome !== "intervalo_lanche"; // Habilitado durante o horário normal

        case "retorno_almoco":
          return this.status.nome === "intervalo_almoco"; // Habilitado após o intervalo de almoço

        case "intervalo_lanche":
          return (
            this.status.nome !== "intervalo_almoco" &&
            this.status.nome !== "intervalo_lanche" &&
            this.status.nome !== "fechado"
          ); // Habilitado durante o horário normal

        case "retorno_lanche":
          return (this.status.nome === "intervalo_lanche"); // Habilitado após o intervalo de lanche

        case "trabalho_encerrado":
          return this.status.nome !== "trabalho_encerrado" && this.status.nome !== "fechado"; // Habilitado se o trabalho não estiver encerrado ou fechado

        case "visualizar_quadro":
          return this.status.nome !== "fechado"; // Habilitado enquanto o status não for fechado

        case "saida_com_justificativa":
          return this.status.nome !== "fechado"; // Habilitado durante o horário normal

        case "saida_sem_justificativa":
          return this.status.nome !== "fechado"; // Habilitado durante o horário normal

        case "mudanca_setor":
          return this.status.nome !== "fechado"; // Habilitado durante o horário normal

        case "fim":
          return this.status.nome !== "fechado" && this.status.nome !== ""; // Habilitado se o status não for fechado ou vazio

        default:
          return true; // Por padrão, o botão está habilitado
      }
    },


    pegarCodigoStatus(descricaoStatus) {
      switch (descricaoStatus) {
        case "Início do Expediente":
          return 15;
        case "Intervalo para Lanche":
          return 16;
        case "Retorno do Lanche":
          return 17;
        case "Intervalo para Almoço":
          return 18;
        case "Retorno do Almoço":
          return 19;
        case "Saída com Justificativa":
          return 20;
        case "Saída sem Justificativa":
          return 21;
        case "Encerramento do Expediente":
          return 22;
        case "Mudança de Setor":
          return 23;
        case "Retorno De Ordem Já Trabalhada":
          return 24;

        default:
          return null; // Retorna null se a descrição não corresponder
      }
    },







    abrirDialogo(opcao) {

      this.opcao_selected = opcao;



      if (opcao.routeDesktop === "AberturaExpedienteDesktop") {
        this.navegarParaRota(opcao);
        return;
      }

      if (opcao.routeDesktop === "ConsultaQuadroHorarioMobile") {
        this.navegarParaRota(opcao);
        return;
      }


      if (opcao.local == 'abrirQuadroFuncionarios') {
        this.abrirQuadroFuncionarios();
        return;
      }

      if (opcao.local == 'saida_com_justificativa') {
        this.abrirQuadroFuncionarios();
        return;
      }
      if (opcao.local == 'saida_sem_justificativa') {
        this.abrirQuadroFuncionarios();
        return;
      }
      if (opcao.local == 'saida_sem_justificativa') {
        this.abrirQuadroFuncionarios();
        return;
      }
      if (opcao.local == 'mudanca_setor') {
        this.abrirQuadroFuncionarios();
        return;
      }



      this.statusDialogo = opcao.titulo;
      this.acaoSelecionada = opcao.acao;
      this.mostrarDialogoConfirmacao = true;
    },

    fecharDialogoConfirmacao() {
      this.mostrarDialogoConfirmacao = false;
    },


    // Método para buscar os detalhes da ordem com base em id_ordem e id_status
    getDetalhesOrdem(idOrdem, idStatus) {
      const ordemDetalhes = this.ordensDoSetor.find(
        (ordem) => ordem.id_ordem === idOrdem && ordem.id_status === idStatus
      );

      if (ordemDetalhes) {
        return {
          etapa: ordemDetalhes.etapa || "Desconhecido",
          cliente: ordemDetalhes.cliente || "Desconhecido",
          modelo: ordemDetalhes.modelo || "Desconhecido",
          quantidade: ordemDetalhes.quantidade || 0,
          id_numero_ordem: ordemDetalhes.id_numero_ordem || "N/A",
          id_pedido: ordemDetalhes.id_pedido || "N/A",
        };
      } else {
        return {
          etapa: "Desconhecido",
          cliente: "Desconhecido",
          modelo: "Desconhecido",
          quantidade: 0,
          id_numero_ordem: "N/A",
          id_pedido: "N/A",
        };
      }

    },



    encontrarStatusMaisRecente(idFuncionario, idOrdem, idOrdemStatus) {
      // Filtrar todas as movimentações do funcionário para a ordem especificada
      const movimentacoesFuncionario = this.expediente.movimentacoes.filter(
        (mov) =>
          mov.funcionario.id === idFuncionario &&
          mov.id_ordem === idOrdem &&
          mov.id_ordem_status === idOrdemStatus
      );

      // Encontrar a movimentação com a data mais recente
      const movimentacaoMaisRecente = movimentacoesFuncionario.reduce((maisRecente, atual) => {
        const dataAtual = new Date(atual.fim_at || atual.inicio_at);
        const dataMaisRecente = new Date(maisRecente.fim_at || maisRecente.inicio_at);

        return dataAtual > dataMaisRecente ? atual : maisRecente;
      });

      // Retornar o status mais recente (id_status_fim ou id_status_inicio)
      return this.getStatusAtualFuncionario(
        movimentacaoMaisRecente.id_status_fim || movimentacaoMaisRecente.id_status_inicio
      );
    },


    abrirQuadroFuncionarios() {
      this.quadroFuncionarios = [];
      const funcionariosUnicos = new Map(); // Usar Map para rastrear combinações únicas

      this.expediente.movimentacoes.forEach((mov) => {
        // Filtrar apenas movimentações com id_status_fim === null
        if (mov.id_status_fim === null) {
          // Obter os detalhes da ordem
          const detalhesOrdem = this.getDetalhesOrdem(mov.id_ordem, mov.id_ordem_status);

          // Criar uma chave única baseada nos campos necessários
          const chaveUnica = `${mov.id_abertura}-${mov.funcionario.id}-${mov.id_ordem}-${mov.id_ordem_status}`;

          // Verificar se já existe no Map
          if (!funcionariosUnicos.has(chaveUnica)) {
            // Encontrar o status mais recente com base no id_status_fim ou id_status_inicio
            const statusMaisRecente = this.encontrarStatusMaisRecente(
              mov.funcionario.id,
              mov.id_ordem,
              mov.id_ordem_status
            );

            const horaInicio = mov.inicio_at || "N/A"; // Hora de início
            const horaFim = mov.fim_at || "N/A"; // Hora de fim

            // Adicionar funcionário único ao Map
            funcionariosUnicos.set(chaveUnica, {
              id_funcionario: mov.funcionario.id,
              nome: mov.funcionario.nome,
              cargo: mov.funcionario.cargo?.nome || "Desconhecido",
              id_abertura: mov.id_abertura,
              id_ordem: mov.id_ordem,
              id_pedido: detalhesOrdem.id_pedido,
              id_status: mov.id_ordem_status,
              modelo: detalhesOrdem.modelo,
              etapa: detalhesOrdem.etapa,
              numero_ordem: detalhesOrdem.id_numero_ordem,
              numero_pedido: detalhesOrdem.id_pedido,
              quantidade: detalhesOrdem.quantidade,
              setor: this.setorSelecionado?.descricao_setor || "Desconhecido",
              selecionado: false, // Adiciona campo de seleção
              status_atual: statusMaisRecente, // Status mais recente do funcionário
              hora_inicio: horaInicio, // Hora de início
              hora_fim: horaFim, // Hora de fim
            });
          }
        }
      });

      // Converter o Map para um array, ordenar e atribuir a `quadroFuncionarios`
      this.quadroFuncionarios = Array.from(funcionariosUnicos.values()).sort((a, b) => a.nome.localeCompare(b.nome));

      // Atualizar valores únicos para os filtros
      this.nomesUnicos = [
        ...new Set(this.quadroFuncionarios.map((func) => func.nome)),
      ].map((nome) => ({
        text: nome,
        value: nome,
        label: `${nome}`, // Campo extra para exibição
      }));

      this.ordensUnicas = [
        ...new Set(this.quadroFuncionarios.map((func) => func.numero_ordem)),
      ].map((ordem) => ({
        text: `Ordem ${ordem}`,
        value: ordem,
        label: `${ordem}`, // Campo extra para exibição
      }));

      this.pedidosUnicos = [
        ...new Set(this.quadroFuncionarios.map((func) => func.numero_pedido)),
      ].map((pedido) => ({
        text: `Pedido ${pedido}`,
        value: pedido,
        label: `${pedido}`, // Campo extra para exibição
      }));

      this.statasUnicos = [
        ...new Set(this.quadroFuncionarios.map((func) => func.status_atual)),
      ].map((status) => ({
        text: `Status ${status}`,
        value: status,
        label: `${status}`, // Campo extra para exibição
      }));

      // Exibe o diálogo
      this.mostrarDialogo = true;
    },



    getStatusAtualFuncionario(idStatus) {
      // console.log('idStatus', idStatus);

      // 15  SIM                E              abertura_dia             Início do expediente para o setor ou funcionário             (NULL)  2025-01-07 20:51:41    2025-01-07 22:00:
      // 16  NAO                S              intervalo_lanche         Intervalo para lanche durante o expediente                   (NULL)  2025-01-07 20:51:41    2025-01-08 12:11:24
      // 17  SIM                E              retorno_lanche           Retorno do intervalo para lanche                             (NULL)  2025-01-07 20:51:41    2025-01-07 22:00:37
      // 18  NAO                S              intervalo_almoco         Intervalo para almoço durante o expediente                   (NULL)  2025-01-07 20:51:41    2025-01-07 22:00:40
      // 19  SIM                E              retorno_almoco           Retorno do intervalo para almoço                             (NULL)  2025-01-07 20:51:41    2025-01-07 22:00:43
      // 20  NAO                F              saida_com_justificativa  Saída do funcionário com justificativa                       (NULL)  2025-01-07 20:51:41    2025-01-08 14:35:18
      // 21  NAO                F              saida_sem_justificativa  Saída do funcionário sem justificativa                       (NULL)  2025-01-07 21:57:01    2025-01-08 14:35:17
      // 22  NAO                F              fim                      Encerramento do expediente para o setor ou funcionário       (NULL)  2025-01-07 20:51:41    2025-01-07 22:00:49
      // 23  NAO                F              mudanca_setor            Funcionário mudor de setor.                                  (NULL)  2025-01-08 14:34:58    2025-01-08 14:35:15

      switch (idStatus) {
        case 15:
          return "Início do Expediente";
        case 16:
          return "Intervalo para Lanche";
        case 17:
          return "Retorno do Lanche";
        case 18:
          return "Intervalo para Almoço";
        case 19:
          return "Retorno do Almoço";
        case 20:
          return "Saída com Justificativa";
        case 21:
          return "Saída sem Justificativa";
        case 22:
          return "Encerramento do Expediente";
        case 23:
          return "Mudança de Setor";
          case 24:
          return "Retorno De Ordem Já Trabalhada";
        default:
          return "Trabalhando";
      }


    },






    fecharQuadroFuncionarios() {
      this.mostrarDialogo = false;
      this.limparFiltros();
    },

    formatarDataHora(data) {
      if (!data) return null; // Verifica se a data é válida

      const date = new Date(data);
      const dia = date.getDate().toString().padStart(2, "0");
      const mes = (date.getMonth() + 1).toString().padStart(2, "0"); // Meses começam em 0
      const ano = date.getFullYear();
      const horas = date.getHours().toString().padStart(2, "0");
      const minutos = date.getMinutes().toString().padStart(2, "0");
      const segundos = date.getSeconds().toString().padStart(2, "0");

      return `${dia}-${mes}-${ano} ${horas}:${minutos}:${segundos}`;
    },


    async buscarChefeSetor(id) {
      try {
        this.mensagemDialog = "Buscando o setor do chefe.";
        this.loading = true;
        this.loadingDialog = true;

        // Chama a API para obter os dados
        const response = await aberturaExpedienteService.obterChefeSetor(id);

        // Verifica se a resposta possui o formato esperado
        if (response) {
          // Pega o primeiro setor retornado
          const setor = response;

          // Preenche os dados do setor
          this.chefeSelecionado = setor.chefe;
          this.expediente = setor.expediente_abertura;
          this.id_chefe_setor = setor.id;
          this.setorSelecionado = this.setores.find(
            (setor) => setor.id === this.id_chefe_setor
          );
          this.id_setor = this.setorSelecionado?.id || "Desconhecido";
          if (this.expediente && this.expediente.status_atual) {
            this.status = this.expediente.status_atual;
          } else {
            this.status.nome = "fechado"; // Valor padrão caso o status_atual não exista
          }


          // Preenche as ordens do setor
          if (setor.setores_ordens && setor.setores_ordens.length > 0) {
            this.ordensDoSetor = setor.setores_ordens.map((ordem) => ({
              id: ordem.id || "ID não informado",
              id_ordem: ordem.id_ordem || "ID não informado",
              id_ordem_status: ordem.id_ordem_status || "Status não informado",
              nome_setor: ordem.setodescricao_setor || "Setor não inf ormado",
              id_numero_ordem: ordem.ordem_producao?.id_ordem ?? "N/A",
              id_pedido: ordem.ordem_producao?.id_pedido ?? "N/A",
              etapa: ordem.ordem_producao_status?.producao_status_tipo?.producao_status ?? "Etapa não definida",
              id_status: ordem.id_ordem_status ?? "Status não informado",
              expediente: ordem.expediente_abertura ?? "Expediente não informado",
              cliente: ordem.ordem_producao?.cliente?.nome ?? "Desconhecido",
              modelo: ordem.ordem_producao?.modelo?.descricao ?? "Modelo não informado",
              quantidade: ordem.ordem_producao?.quantidade ?? 0,
              previsao_entrega: ordem.ordem_producao?.previsao_entrega ?? "Não informado",
              funcionariosSelecionados: [], // Inicializado como array vazio
            }));
          }

          else {
            this.ordensDoSetor = [];
            toast.warning("Nenhuma ordem encontrada para este setor.");
          }
        } else {
          // Caso o formato da resposta não seja válido ou vazio
          throw new Error("Nenhum setor encontrado para o chefe especificado.");
        }
      } catch (error) {
        // Captura e exibe erros no console e para o usuário
        console.error("Erro ao carregar dados:", error);
        this.errorDialog = true;
        toast.error(error.message || "Erro ao carregar dados.");
      } finally {
        // Sempre desativa os indicadores de carregamento
        this.loading = false;
        this.loadingDialog = false;
      }
    }
    ,

    // Método para buscar o chefe a partir do ID
    async buscarChefe() {
      if (this.loading) return; // Evita buscar enquanto carrega

      let idChefe = this.id_chefe.trim().toUpperCase();

      // Remover os primeiros 3 caracteres se forem letras
      if (/^[A-Z]{3}/.test(idChefe)) {
        idChefe = idChefe.substring(3);
      }

      // Converter o ID para inteiro, ignorando entradas inválidas
      const idChefeInt = parseInt(idChefe, 10);

      if (isNaN(idChefeInt)) {
        toast.error("O ID deve ser um número válido.");
        return;
      }

      // Após selecionar o chefe, carregar os setores
      await this.carregarSetores();

      await this.buscarChefeSetor(idChefeInt);

      this.limparFiltros();
      this.mostrarDialogoConfirmacaoFuncinario = false;
      this.mostrarDialogo = false;



    },


    // Método para carregar setores após selecionar o chefe
    async carregarSetores() {
      try {
        this.mensagemDialog = "Carregando setores...";
        this.loadingDialog = true;
        const response = await maquinaMapaService.fetchSetores();
        if (response && Array.isArray(response)) {
          this.setores = response;
        } else {
          throw new Error("Formato de dados inválido.");
        }
      } catch (error) {
        console.error("Erro ao carregar setores:", error);
        this.errorDialog = true;
        toast.error("Erro ao carregar setores. Tente novamente.");
      } finally {
      }
    },

    updateIsMobile() {
      this.isMobile = window.innerWidth <= 600;
    },


    navegarParaRota(opcao) {

      // esse dialog e opcao de mudancas de qualquer status.
      if (opcao.local === 'abrirQuadroFuncionarios') {

        this.abrirQuadroFuncionarios();
        return;
      }

      if (opcao.routeMobile === "ConsultaQuadroHorarioMobile") {

        // Exemplo: criamos o array de filtros com 'id_setor' e 'data_abertura'
        function dataAtual() {
          const now = new Date();


          const ano = now.getFullYear();
          const mes = String(now.getMonth() + 1).padStart(2, '0');
          const dia = String(now.getDate()).padStart(2, '0');
          // const hora = String(now.getHours()).padStart(2, '0');
          // const minuto = String(now.getMinutes()).padStart(2, '0');
          // const segundo = String(now.getSeconds()).padStart(2, '0');

          return `${ano}-${mes}-${dia}`;
        }
        // console.log('expidente heiltor', this.expediente.id);

        const filtros = [
          {
            id_setor: this.setorSelecionado?.id || null,
            data_abertura: this.expediente?.data_abertura || dataAtual(),
            id_abertura: this.expediente?.id
          },
        ];

        // Navegamos para a rota, passando a query "filtros" como JSON
        this.$router
          .push({
            name: "ConsultaQuadroHorarioMobile",
            query: {
              filtros: JSON.stringify(filtros),
            },
          })
          .catch((err) => {
            console.error(`Erro ao navegar para a rota ConsultaQuadroHorarioMobile:`, err.message);
          });
        return;
      }

      const route = this.isMobile ? opcao.routeMobile : opcao.routeDesktop;
      this.$router.push({ name: route }).catch((err) => {
        console.error(`Erro ao navegar para a rota ${route}:`, err.message);
      });
    },
    voltarMenu() {
      this.$router.push({ name: "MenuDefault" }).catch((err) => {
        console.error("Erro ao voltar para o menu principal:", err.message);
      });
    },

  },
  computed: {
    // Adicionando userStore como propriedade computada
    userStore() {
      return useUserStore();
    },
    
    funcionariosSelecionadosDetalhes() {
      // Verifica se `quadroFuncionarios` é uma array antes de tentar filtrar
      if (!Array.isArray(this.quadroFuncionarios)) {
        return []; // Retorna um array vazio se não for
      }

      // Filtra os funcionários selecionados
      return this.quadroFuncionarios.filter((funcionario) => funcionario.selecionado === true);
    },

    nomeUsuario() {
      return this.userStore.objetoUsuario?.name || "Sem Usuário";
    },
    ObjUsuario() {
      return this.userStore.objetoUsuario || "Sem Usuário";
    },
  },


  created() {
    this.id_chefe = String(this.ObjUsuario.id_funcionario).trim();
    this.buscarChefe();
  },
  mounted() {
    window.addEventListener("resize", this.updateIsMobile);

    this.mensagemDialog = "Carregando dados...";
    this.loadingDialog = true;
    this.$nextTick(async () => {
      this.mensagemDialog = "Carregando dados.";

      // await this.carregarMaquinas();

    });



  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  },
};
</script>

<style scoped>
.layout-container {
  height: auto;
  display: flex;
  flex-direction: column;
}

.header-bar {
  position: fixed;
  top: 0;

  left: 0;
  right: 0;
  z-index: 10;
}

.content-area {
  flex: 1;
  padding-top: 56px;
  overflow-y: auto;
  margin-bottom: 80px;
}

.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: #fafafa;
  padding: 10px 0;
  box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.1);
}

.menu-expediente {
  gap: 10px;
}

.option-card {
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.option-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.3);
}

.menu-icon {
  background: rgba(255, 255, 255, 0.3);
  padding: 16px;
  border-radius: 50%;
}

.expediente-info {
  color: #424242;
  margin: 0;
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .menu-expediente {
    gap: 12px;
  }
}
</style>
